import React, { useState, useEffect, Fragment } from "react";
import Swal from "sweetalert2";
import CustomSelect from "../components/CustomSelect";

import {
  getConfig,
  sendMail,
  getDepartamentos,
  getEstados,
} from "../repository";
import ResponsiveHeader from "../components/ResponsiveHeader";
import Footer2 from "../components/Footer2";

const Contact = () => {
  const [eMailReceiver, setEmailReceiver] = useState("");
  const [nombre, setNombre] = useState("");
  const [telefono, setTelefono] = useState("");
  const [comentarios, setComentarios] = useState("");
  const [deptoDestino, setDeptoDestino] = useState([]);
  const [estados, setEstados] = useState([]);
  const [departamento, setDepartamento] = useState("");
  const [departamentoNombre, setDepartamentoNombre] = useState("");
  const [estado, setEstado] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [correo, setCorreo] = useState("");
  const [errors, setErrors] = useState({});
  const [website, setWebsite] = useState(""); // Honeypot field
  const [enviando, setEnviando] = useState(false);

  // Toast configuration
  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  // Error style helper
  const errorStyle = {
    borderColor: "#dc3545",
    boxShadow: "0 0 0 0.2rem rgba(220, 53, 69, 0.25)",
    animation: "shake 0.5s"
  };

  function ValidaEMailEnviado() {
    Swal.fire({
      text: "Correo enviado",
      icon: "success",
      confirmButtonColor: "#f7a209",
    });
    setNombre("");
    setTelefono("");
    setCorreo("");
    setComentarios("");
    setDepartamento("");
    setDepartamentoNombre("");
    setEstado("");
    setCiudad("");
    setErrors({});
    setWebsite("");
  }

  useEffect(() => {
    obtieneDepartamentos();
    obtieneEstados();
  }, []);

  // Validación de email simple
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  function enviarEMail(e) {
    e.preventDefault();

    // Validación de campos requeridos
    const newErrors = {};
    if (!departamento || departamento === "") newErrors.departamento = true;
    if (!nombre || nombre.trim() === "") newErrors.nombre = true;
    if (!estado || estado === "") newErrors.estado = true;
    if (!ciudad || ciudad.trim() === "") newErrors.ciudad = true;
    if (!correo || correo.trim() === "" || !isValidEmail(correo)) newErrors.correo = true;
    if (!telefono || telefono.trim() === "") newErrors.telefono = true;
    if (!comentarios || comentarios.trim() === "") newErrors.comentarios = true;

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      Toast.fire({
        icon: "warning",
        text: "Completa todos los campos requeridos",
      });
      return;
    }

    setErrors({});
    setEnviando(true);

    sendMail(
      eMailReceiver,
      nombre,
      correo,
      telefono,
      comentarios,
      estado,
      ciudad,
      departamentoNombre,
      website // Honeypot
    ).then((res) => {
      setEnviando(false);
      if (res.success) {
        ValidaEMailEnviado();
      } else {
        Swal.fire({
          text: res.message || "Error al enviar el correo.",
          icon: "error",
          confirmButtonColor: "#f7a209",
        });
      }
    });
  }

  function obtieneDepartamentos() {
    getDepartamentos()
      .then((response) => {
        if (response.data.status === "success") {
          var items = response.data.result.map((item) => {
            return { value: item.idCatalogoDepto, text: item.descripcion };
          });
          setDeptoDestino([{ value: "", text: "Seleccione Departamento" }].concat(items));
        } else {
          Swal.fire({
            title: "Error",
            text: "Error al obtener la información de Departamentos",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch((err) =>
        Swal.fire({
          title: "Error",
          text: "Error al obtener la información de Departamentos",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  }

  function obtieneEstados() {
    getEstados()
      .then((response) => {
        if (response.data.status === "success") {
          var items = response.data.result.map((item) => {
            return { value: item.descripcion, text: item.descripcion };
          });
          setEstados([{ value: "", text: "Seleccione Estado" }].concat(items));
        } else {
          Swal.fire({
            title: "Error",
            text: "Error al obtener la información de Estados",
            icon: "error",
            confirmButtonColor: "#f7a209",
          });
        }
      })
      .catch((err) =>
        Swal.fire({
          title: "Error",
          text: "Error al obtener la información de Estados",
          icon: "error",
          confirmButtonColor: "#f7a209",
        })
      );
  }

  function obtieneEmailDestino(deptoId) {
    if (deptoId && deptoId !== "0") {
      getConfig(deptoId).then((response) => {
        if (
          response.data.status === "success" &&
          response.data.result.length > 0
        ) {
          setEmailReceiver(response.data.result[0].value);
        }
      });
    }
  }

  return (
    <Fragment>
      <ResponsiveHeader />

      {/* Hero Banner */}
      <div className="contacto-hero">
        <div className="container">
          <div className="contacto-hero-content">
            <h1 className="contacto-hero-title">Contacto</h1>
            <p className="contacto-hero-subtitle">
              Estamos aquí para ayudarte. Envíanos tus dudas o comentarios.
            </p>
          </div>
        </div>
      </div>

      {/* Sección Principal del Formulario */}
      <div className="contacto-section">
        <div className="container">
          <div className="contacto-form-container">
            <form
              id="contactForm"
              name="sentMessage"
              action="?"
              method="POST"
              noValidate="novalidate"
            >
              {/* Honeypot field - hidden from users, bots will fill it */}
              <div style={{ position: "absolute", left: "-9999px" }} aria-hidden="true">
                <label htmlFor="fax_number">Fax</label>
                <input
                  type="text"
                  id="fax_number"
                  name="fax_number"
                  tabIndex="-1"
                  autoComplete="new-password"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div>

              <div className="contacto-form-grid">
                {/* Columna Izquierda */}
                <div className="contacto-form-column">
                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-building"></i>
                      Departamento
                    </label>
                    <CustomSelect
                      name="departamento"
                      value={departamento}
                      options={deptoDestino}
                      onChange={(selectedValue) => {
                        const selectedItem = deptoDestino.find(item => item.value === selectedValue);
                        setDepartamento(selectedValue);
                        setDepartamentoNombre(selectedItem ? selectedItem.text : "");
                        setErrors(prev => ({ ...prev, departamento: false }));
                        obtieneEmailDestino(selectedValue);
                      }}
                      hasError={errors.departamento}
                    />
                  </div>

                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-user"></i>
                      Nombre
                    </label>
                    <input
                      className="contacto-input"
                      id="nombre"
                      name="nombre"
                      type="text"
                      placeholder="Tu nombre completo"
                      value={nombre}
                      style={errors.nombre ? errorStyle : {}}
                      onChange={(e) => {
                        setNombre(e.target.value);
                        setErrors(prev => ({ ...prev, nombre: false }));
                      }}
                    />
                  </div>

                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-map-marker-alt"></i>
                      Estado
                    </label>
                    <CustomSelect
                      name="estado"
                      value={estado}
                      options={estados}
                      onChange={(selectedValue) => {
                        setEstado(selectedValue);
                        setErrors(prev => ({ ...prev, estado: false }));
                      }}
                      hasError={errors.estado}
                    />
                  </div>

                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-city"></i>
                      Ciudad
                    </label>
                    <input
                      className="contacto-input"
                      id="ciudad"
                      name="ciudad"
                      type="text"
                      placeholder="Tu ciudad"
                      value={ciudad}
                      style={errors.ciudad ? errorStyle : {}}
                      onChange={(e) => {
                        setCiudad(e.target.value);
                        setErrors(prev => ({ ...prev, ciudad: false }));
                      }}
                    />
                  </div>

                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-envelope"></i>
                      Email
                    </label>
                    <input
                      className="contacto-input"
                      id="correo"
                      name="correo"
                      type="email"
                      placeholder="tu@email.com"
                      value={correo}
                      style={errors.correo ? errorStyle : {}}
                      onChange={(e) => {
                        setCorreo(e.target.value);
                        setErrors(prev => ({ ...prev, correo: false }));
                      }}
                    />
                  </div>
                </div>

                {/* Columna Derecha */}
                <div className="contacto-form-column">
                  <div className="contacto-form-group">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-phone"></i>
                      Teléfono
                    </label>
                    <input
                      className="contacto-input"
                      id="telefono"
                      name="telefono"
                      type="tel"
                      placeholder="Tu número de teléfono"
                      value={telefono}
                      style={errors.telefono ? errorStyle : {}}
                      onChange={(e) => {
                        setTelefono(e.target.value);
                        setErrors(prev => ({ ...prev, telefono: false }));
                      }}
                    />
                  </div>

                  <div className="contacto-form-group contacto-form-group-textarea">
                    <label className="contacto-form-label">
                      <i className="fa-solid fa-comment"></i>
                      Comentarios
                    </label>
                    <textarea
                      className="contacto-textarea"
                      id="comentarios"
                      name="comentarios"
                      placeholder="Escribe tu mensaje aquí..."
                      rows="6"
                      value={comentarios}
                      style={errors.comentarios ? errorStyle : {}}
                      onChange={(e) => {
                        setComentarios(e.target.value);
                        setErrors(prev => ({ ...prev, comentarios: false }));
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="contacto-form-submit">
                <button
                  id="sendMessageButton"
                  onClick={(e) => enviarEMail(e)}
                  className="contacto-submit-btn"
                  type="submit"
                  disabled={enviando}
                >
                  {enviando ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-paper-plane"></i>
                      Enviar Mensaje
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer2 />
    </Fragment>
  );
};

export default Contact;
